import { fromJS } from 'immutable'
import {
  AUTH_REQUEST,
  AUTH_SUCCESS,
  AUTH_FAILURE,
  AUTH_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case AUTH_REQUEST:
      return state
        .set('isFetching', true)
    case AUTH_SUCCESS:
      return state
        .set('user', action.payload.user)
        .set('supervisor', action.payload.supervisor)
        .set('inboxNotification', action.payload.inboxNotification)
        .set('status', 200)
        .set('isFetching', false)
    case AUTH_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('isAuthenticated', false)
          .set('status', fromJS(action.payload.response.statusCode))
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case AUTH_RESET:
      return state
        .set('redirect', false)
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth/auth-auth-reducer.js